import { useState, useEffect } from 'react';
import './Home.css';
import { Link } from "react-router-dom";
import { Totals } from './Totals';
import { showModal } from '../Helpers/FormHelper';
import { ModalPopup } from '../common/ModalPopup';
import { PageInfo } from '../common/PageInfo';
import { ImageInfo } from '../common/ImageInfo';

export function Home() {
  const [popupMessage, setPopupMessage] = useState("");
  const [popupTitle, setPopupTitle] = useState("");
  const [modal, setModal] = useState(false);

  useEffect(() => {
    console.log('component mounted!');
  }, []);

  const sendAnyways = (e) => {
    e.preventDefault();
    showModal(e, setModal, false);
  }

  const displayPopup = (e) => {
    setPopupMessage(`Please email <a href="mailto:${window.config.SiteContactEmail}">${window.config.SiteContactEmail}</a> or call ${window.config.SiteContactPhone}.`);
    setPopupTitle(`Contact Us`);
    showModal(e, setModal, true);
  };

  return (
    <div>
      <ImageInfo pageId={1} />
      <PageInfo pageId={1} />
      <div className="row">
        <div className="col-sm-4"></div>
        <div className="col-sm-2">
          <Link to="/donate" className="btn blm-btn-primary btn-lg btn-block wide-link" style={{ marginBottom: '5px', marginTop: '5px' }}>Support Now</Link>
        </div>
        <div className="col-sm-2">
          <Link to="/" className="btn blm-btn-primary btn-lg btn-block wide-link" style={{ marginBottom: '5px', marginTop: '5px' }} onClick={displayPopup}>Contact Now</Link>
        </div>
        <div className="col-sm-4"></div>
      </div>
      <ModalPopup message={popupMessage} title={popupTitle} isAddressCheck={false} setModal={setModal} modal={modal} sendAnyways={sendAnyways} />
      <Totals />
    </div>
  );
}
